var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11.2174,
    height: 19.0014,
    viewBox: "0 0 11.2174 19.0014",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5042 18.122C3.7828 18.4008 4.11361 18.6219 4.47771 18.7728C4.84181 18.9237 5.23207 19.0014 5.6262 19.0014C6.02033 19.0014 6.41059 18.9237 6.7747 18.7728C7.1388 18.6219 7.4696 18.4008 7.7482 18.122L10.9592 14.911C11.1314 14.7206 11.2237 14.4713 11.2171 14.2147C11.2105 13.958 11.1055 13.7138 10.9238 13.5325C10.7421 13.3512 10.4976 13.2467 10.241 13.2406C9.98437 13.2346 9.73524 13.3274 9.5452 13.5L6.6192 16.427L6.6262 1C6.6262 0.734784 6.52085 0.48043 6.33331 0.292893C6.14577 0.105357 5.89142 0 5.6262 0V0C5.36099 0 5.10663 0.105357 4.9191 0.292893C4.73156 0.48043 4.6262 0.734784 4.6262 1L4.6172 16.408L1.7072 13.5C1.51956 13.3125 1.26512 13.2072 0.999849 13.2073C0.734579 13.2074 0.480211 13.3129 0.292703 13.5005C0.105195 13.6881 -9.37056e-05 13.9426 6.25777e-08 14.2079C9.38308e-05 14.4731 0.105562 14.7275 0.293202 14.915L3.5042 18.122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadArrow);
export default __webpack_public_path__ + "static/media/icon_download_arrow.00f664ac94e82ed8b5fc4bc0cc399048.svg";
export { ForwardRef as ReactComponent };